import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, Renderer2 } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppConstants } from 'src/app/classes/app/constants';
import { IonContent, IonHeader, ModalController, Platform } from '@ionic/angular';
import { INavParams, IViewSpecs } from 'src/app/classes/def/nav-params/general';
import { ThemeColors } from 'src/app/classes/def/app/theme';
import { IPopoverActions } from 'src/app/classes/def/app/modal-interaction';
import { EModalTypes } from 'src/app/classes/utils/uiext';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { AnalyticsService } from 'src/app/services/general/apis/analytics';
import { BackButtonService } from 'src/app/services/general/ui/back-button';
import { ResourcesCoreDataService } from 'src/app/services/data/resources-core';
import { SettingsManagerService } from 'src/app/services/general/settings-manager';
import { ERouteDef } from 'src/app/app-utils';
import { NavParamsService, INavParamsInfo } from 'src/app/services/app/nav-params';
import { ENavParamsResources } from 'src/app/classes/def/nav-params/resources';
import { UiExtensionStandardService } from 'src/app/services/general/ui/ui-extension-standard';
import { EAppIcons, EAppIconsStandard, EPhotos } from 'src/app/classes/def/app/icons';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PopupFeaturesService } from 'src/app/services/app/modules/minor/popup-features';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { FileManagerService } from 'src/app/services/media/file';
import { IFaqCategory } from 'src/app/classes/def/support/support';
import { EFAQCategories, SupportDataService } from 'src/app/services/data/support';
import { IValidateNavParams } from 'src/app/classes/def/nav-params/support';
import { StoryDataService } from 'src/app/services/data/story';
import { InventoryDataService } from 'src/app/services/data/inventory';
import { ETutorialEntries } from 'src/app/classes/def/app/messages';
import { ITutorial } from 'src/app/classes/def/app/tutorials';
import { AuthRequestService } from 'src/app/services/general/auth-request/auth-request';
import { IGenericResponse } from 'src/app/classes/def/requests/general';
import { Util } from 'src/app/classes/general/util';
import { EmailFormatUils } from 'src/app/services/utils/email-format';

@Component({
    selector: 'app-validate',
    templateUrl: './validate.page.html',
    styleUrls: ['./validate.page.scss'],
    animations: [
        trigger('showState', [
            state('inactive', style({
                // transform: 'translateY(-100%)',
                opacity: 0
            })),
            state('active', style({
                // transform: 'translateY(0)',
                opacity: 1
            })),
            transition('inactive => active', animate(AppConstants.animationMode)),
            transition('active => inactive', animate(AppConstants.animationMode))
        ])
    ],
    encapsulation: ViewEncapsulation.None
})
export class ValidatetPage implements OnInit, OnDestroy {
    @ViewChild("header", { read: IonHeader, static: false }) header: HTMLElement;
    @ViewChild("content", { read: IonContent, static: false }) content: HTMLElement;

    website: string = AppConstants.links.website;
    testFlightUrl: string = AppConstants.links.testFlightUrl;
    appStoreUrl: string = AppConstants.links.appStoreUrl;
    playStoreUrl: string = AppConstants.links.playStoreUrl;

    validationMessage: string = "";

    photoUrl: string = EPhotos.balloonLandscape;

    title: string = "Validate Account";

    np: INavParams = null;
    vs: IViewSpecs;
    isModal: boolean = false;

    params: IValidateNavParams;

    tutorialVideoUrl: string = null;
    extDataLoaded: boolean = false;
    faqCategories: IFaqCategory[];

    linkPreview: boolean = false;

    token: string = null;
    userId: number = null;

    theme: string = "theme-light theme-light-bg";

    loaded: boolean = true;
    appIconsStandard = EAppIconsStandard;
    appIcons = EAppIcons;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public uiext: UiExtensionService,
        public uiextStandard: UiExtensionStandardService,
        public plt: Platform,
        public analytics: AnalyticsService,
        public backButton: BackButtonService,
        public resourcesProvider: ResourcesCoreDataService,
        public settingsProvider: SettingsManagerService,
        public modalCtrl: ModalController,
        public nps: NavParamsService,
        public popupFeatures: PopupFeaturesService,
        public domSanitizer: DomSanitizer,
        public fileManager: FileManagerService,
        public renderer: Renderer2,
        public support: SupportDataService,
        public storyDataService: StoryDataService,
        public inventoryDataService: InventoryDataService,
        public authRequest: AuthRequestService,
        public meta: Meta
    ) {
        // customize default values of carousels used by this component tree
        // carouselConfig.interval = 2000;
        // carouselConfig.keyboard = true;
        // carouselConfig.pauseOnHover = true;
    }

    ionViewWillEnter() {
        console.log("will enter");
        this.renderer.setStyle(this.header['el'], 'webkitTransition', 'top 300ms');
        this.renderer.setStyle(this.content['el'], 'webkitTransition', 'top 300ms');
    }

    onContentScroll(event) {
        let target = event.target;
        let offsetHeader: number = 56;
        let offsetContent: number = 26;
        if (target.scrollTop >= 50) {
            this.renderer.setStyle(this.header['el'], 'top', '-' + offsetHeader + 'px');
            this.renderer.setStyle(this.content['el'], 'top', '-' + offsetContent + 'px');
        } else {
            this.renderer.setStyle(this.header['el'], 'top', '0px');
            this.renderer.setStyle(this.content['el'], 'top', '0px');
        }
    }

    loadTutorialVideoLink() {
        return new Promise<boolean>((resolve) => {
            this.resourcesProvider.getInfoData(ETutorialEntries.storylineTutorialVideo, true).then((tutorial: ITutorial) => {
                // this.tutorialEmbedPDFLink = this.domSanitizer.bypassSecurityTrustResourceUrl(tutorial.description);
                this.tutorialVideoUrl = tutorial.description;
                resolve(true);
            }).catch((err: Error) => {
                console.error(err);
                this.analytics.dispatchError(err, "content");
                resolve(false);
            });
        });
    }

    loadExtData() {
        return new Promise<boolean>(async (resolve) => {
            try {
                let cats: IFaqCategory[] = await this.support.getFaqV2([EFAQCategories.stories]);
                this.faqCategories = cats;
                this.extDataLoaded = true;
            } catch (err) {
                this.analytics.dispatchError(err, "support");
                console.error(err);
            }
            resolve(true);
        });
    }


    ngOnInit() {
        this.analytics.trackView("validate");
        this.nps.checkParamsLoaded().then(() => {
            let npInfo: INavParamsInfo = this.nps.getCombined(ENavParamsResources.validate, null, this.np);
            console.log("nav params: ", npInfo.params);
            let npar = npInfo.params;

            let hasParams: boolean = npInfo.hasParams;
            let promiseParams: Promise<boolean> = new Promise((resolve) => {
                if (hasParams) {
                    console.log(npar);
                    let np: INavParams = npar;
                    if (np && np.params) {
                        this.params = np.params;
                        this.token = this.params.token;
                        this.userId = this.params.userId;
                    }
                    this.vs = np.view;
                    this.isModal = this.vs ? this.vs.isModal : false;
                    this.linkPreview = false;
                    resolve(true);
                } else {
                    this.route.queryParams.subscribe((params: Params) => {
                        if (params) {
                            let data: IValidateNavParams = params as any;
                            this.params = Object.assign({}, data);
                            this.token = this.params.token;
                            this.userId = this.params.userId;
                            console.log("parsed params: ", this.params);
                        }
                        resolve(true);
                    });
                }
            });

            promiseParams.then(() => {
                // can be opened either as a modal or a root page
                this.plt.ready().then(() => {
                    this.backButton.pushOrReplace(() => {
                        this.back();
                    }, this.vs);
                }).catch((err: Error) => {
                    console.error(err);
                });

                this.settingsProvider.getSettingsLoaded(false).then((res) => {
                    if (res) {
                        this.theme = ThemeColors.theme[SettingsManagerService.settings.app.settings.theme.value].css;
                        this.loadAll();
                    }
                }).catch((err: Error) => {
                    console.error(err);
                });
            });
        }).catch((err: Error) => {
            console.error(err);
        });
    }

    validateAccount(userId: number, token: string) {
        return new Promise<boolean>((resolve) => {
            if (userId == null || token == null) {
                this.validationMessage = "<p>Uh oh! Validation error:</p><p>Missing credentials</p>";
                resolve(false);
                return;
            }
            this.authRequest.validateEmailAccount(userId, token).then((res: IGenericResponse) => {
                if (res != null && res.status && res.data) {
                    this.validationMessage = "<p>Yay! Your Leplace account has been validated</p><p>You may continue your activity</p>";
                    resolve(true);
                } else {
                    this.validationMessage = "<p>Uh oh! Validation error:</p><p>" + res.message + "</p>";
                    resolve(false);
                }
            }).catch((err: Error) => {
                console.error(err);
                this.validationMessage = "<p>Uh oh! Validation error:</p><p>" + ((err != null) ? err.message : "") + "</p>";
                resolve(false);
            });
        });
    }

    async loadAll() {
        this.loaded = false;
        await this.loadExtData();
        await this.loadTutorialVideoLink();
        await this.validateAccount(this.userId, this.token);
        this.loaded = true;
    }


    ngOnDestroy() {
        this.backButton.checkPop(this.vs);
    }

    swipeEvent(e) {
        this.backButton.handleSwipeEvent(e);
    }


    /**
     * back to story list
     * @param animate 
     */
    back() {
        if (this.isModal) {
            this.dismissModal();
        } else {
            let navParams: INavParams = {
                view: null,
                params: null
            };
            this.nps.set(ENavParamsResources.home, navParams);
            this.router.navigate([ERouteDef.home], { replaceUrl: true }).then(() => {
            }).catch((err: Error) => {
                console.error(err);
            });
        }
    }

    /**
     * return from modal
     * load story flag shows if the map should load the current story
     * @param animate 
     * @param loadStory 
     */
    dismissModal() {
        setTimeout(() => {
            this.modalCtrl.dismiss().then(() => {
            }).catch((err: Error) => {
                console.error(err);
            });
        }, 1);
    }

    presentPopover() {
        let actions: IPopoverActions = {};
        actions = {
            reload: {
                name: "Reload",
                code: 2,
                icon: EAppIconsStandard.refresh,
                enabled: true
            }
        };

        this.uiextStandard.showStandardModal(null, EModalTypes.options, null, {
            view: {
                fullScreen: false,
                transparent: AppConstants.transparentMenus,
                large: true,
                addToStack: true,
                frame: false
            },
            params: { actions: actions }
        }).then((code: number) => {
            switch (code) {
                case 2:
                    this.loadAll();
                    break;
                default:
                    break;
            }
        }).catch((err: Error) => {
            console.error(err);
        });
    }

    onZoomImage(_zoom: boolean) {
        // this.zoomState = zoom;
    }

    goToAppStore() {
        Util.openURLAdaptive(this.appStoreUrl);
    }

    goToAppleTestFlight() {
        Util.openURLAdaptive(this.testFlightUrl);
    }

    goToPlayStore() {
        Util.openURLAdaptive(this.playStoreUrl);
    }

    openWebpage() {
        Util.openURLAdaptive(this.website);
    }

    /**
    * open app FB page
    */
    openFBPage() {
        // Util.openURLAdaptive(this.appDetails.fbLink);
        Util.openURLAdaptive("https://www.facebook.com/leplaceglobal/");
    }

    /**
     * write email to developers
     */
    contact() {
        // let link: string = this.appDetails.contactEmail;
        let link: string = "office@leplace.online";
        if (link) {
            link = "mailto:" + link;
            let subject = "Visitor contact from LP Connect";
            let body = "";
            let uri: string = EmailFormatUils.formatExistingContent(link, subject, body);
            // Util.openURLAdaptive(uri);
            this.fileManager.openURLAsAnchor(uri);
        }
    }

    copyToClipboard(code: string) {
        this.popupFeatures.copyToClipboard(code);
    }
}

